import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'cp-customer-snackbar',
  templateUrl: './customer-snackbar.component.html',
  styleUrls: ['./customer-snackbar.component.less']
})
export class CustomerSnackbarComponent implements OnInit {

  constructor(
    public snackBarRef: MatSnackBarRef<CustomerSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any) {
    console.log(data);
  }

  ngOnInit() { }

  get getStatusIcon() {
    switch (this.data.snackType) {
      case 'Success':
        return 'info_20';
      case 'Error':
        return 'error';
      case 'Warn':
        return 'warning';
      case 'Failed':
        return 'failed';
      case 'upload_Success':
        return 'upload_success';
        case 'invitation':
          return 'invitation';
          case 'Deny':
          return 'deny';
          case 'NO_STATUS':
            return 'NO_STATUS';
      default: 'info';
        return 'info';
    }
  }

}
